import React, { useEffect, useState } from 'react';
import { client } from 'shared';
import JobTemplateOption from './JobTemplateOption';
import { BusinessJobTemplateListDTO } from 'parent-portal/forms/JobTemplateModels';
import { EmptyText, Label, Row, Select, Stack } from 'library/ui';
import { useUserContext } from 'UserContext';

export default function JobTemplateListContent({
    address,
    setAddress,
    emptyText,
    selectedJobId,
    setSelectedJobId,
    openJobsOnly = false,
}: {
    address: number | null;
    setAddress: (addressId: number) => void;
    emptyText?: string;
    selectedJobId?: number;
    setSelectedJobId: (jobId?: number) => void;
    openJobsOnly?: boolean;
}) {
    const { user } = useUserContext();
    const [jobTemplates, setJobTemplates] = useState<BusinessJobTemplateListDTO[]>([]);

    useEffect(() => {
        if (!address) return;
        client(`api/job-template/?address=${address}&open_jobs=${openJobsOnly}`).then(setJobTemplates);
    }, [address]);

    function handleAddressChange(value: string) {
        setAddress(parseInt(value));
    }

    return (
        <>
            {user && user.address.length > 0 ? (
                <Row gap="sm">
                    <Label>Location:</Label>
                    <Select
                        value={address || ''}
                        options={user.address
                            .filter((x) => x.can_post_jobs)
                            .map((addr) => {
                                return { key: addr.id.toString(), value: addr.description || '' };
                            })}
                        onChange={handleAddressChange}
                    />
                </Row>
            ) : null}
            <Stack>
                {jobTemplates.length > 0 ? (
                    jobTemplates.map((jobTemplate) => (
                        <JobTemplateOption
                            key={jobTemplate.id}
                            jobTemplate={jobTemplate}
                            selectedJobId={selectedJobId}
                            setSelectedJobId={setSelectedJobId}
                        />
                    ))
                ) : (
                    <EmptyText>
                        {emptyText ?? "Sorry, we couldn't find any recent jobs to duplicate for this location."}
                    </EmptyText>
                )}
            </Stack>
        </>
    );
}
